import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="text-center">
        <h1 className="text-8xl font-bold text-gray-300 mb-4">404</h1>
        <p className="text-2xl font-semibold text-gray-700 mb-2">ページが見つかりません</p>
        <p className="text-gray-500 mb-8">
          お探しのページは削除されたか、名前が変更されたか、現在利用できない可能性があります。
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-2 text-white bg-blue-500 hover:bg-blue-600 rounded-lg shadow-md transition duration-200"
        >
          ホームへ戻る
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
